import { render, staticRenderFns } from "./RelatorioPedidosListFiltroModalItemInput.vue?vue&type=template&id=7bc13169"
import script from "./RelatorioPedidosListFiltroModalItemInput.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidosListFiltroModalItemInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports